import { Link } from 'react-router-dom';

import { VENUES } from '@/data/events';
import { fmtDateCompact } from '@/lib/format';
import type { ArchiveEvent, MoctEvent } from '@/types';

import styles from './PlayedList.module.css';

export type PlayedEvent = (MoctEvent | ArchiveEvent) & { isUpcoming: boolean };

interface PlayedListProps {
  played: PlayedEvent[];
}

export default function PlayedList({ played }: PlayedListProps) {
  if (played.length === 0) return null;

  return (
    <section className={styles.section}>
      <header className={styles.head}>
        <span className={styles.num}>/ 02</span>
        <span className={styles.ttl}>PLAYED AT MOCT</span>
        <span className={styles.meta}>{played.length} TRANSMISSIONS</span>
      </header>
      <div className={styles.grid}>
        {played.map((e) => {
          const v = VENUES[e.venue];
          return (
            <Link
              key={e.code}
              to={e.isUpcoming ? `/events/${e.id}` : '/events'}
              className={styles.row}
            >
              <span className={styles.code}>{e.code}</span>
              <div>
                <div className={styles.title}>{e.title}</div>
                <div className={styles.sub}>
                  {fmtDateCompact(e.date)} · {v.name}{' '}
                  {e.isUpcoming ? '· UPCOMING' : '· ARCHIVE'}
                </div>
              </div>
              <span className={styles.arrow}>VIEW</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
